import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=e732de2c&scoped=true"
import script from "./order_detail.vue?vue&type=script&lang=js"
export * from "./order_detail.vue?vue&type=script&lang=js"
import style0 from "./order_detail.vue?vue&type=style&index=0&id=e732de2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e732de2c",
  null
  
)

export default component.exports